/**
 * Warm transfer product decisions (plan v1).
 * - Queue: consult with whichever agent answers; context via active-context API.
 * - Teams: PSTN only; all control on Agent 1; no ESP UI for Teams users.
 * - Complete without conference: allowed from private consult.
 * - Outbound customer calls: warm enabled (voice only, inbound and outbound).
 * - Post-cancel: customer stays on hold; manual resume from call banner.
 */
export const WARM_TRANSFER_PRODUCT = {
  allowCompleteWithoutConference: true,
  warmTransferInboundVoiceOnly: false,
  teamsAgent2EspUi: false,
  customerStaysOnHoldAfterCancel: true,
} as const;

export type WarmTransferStage =
  | 'idle'
  | 'selectTarget'
  | 'holdingCustomer'
  | 'waitingForAccept'
  | 'dialing'
  | 'consulting'
  | 'conference'
  | 'completing'
  | 'cancelling'
  | 'cancelled'
  | 'completed';

export type WarmTransferTargetKind =
  | 'spog_agent'
  | 'teams_user'
  | 'teams_group'
  | 'queue';

/** True while a warm transfer session is active (consult in flight). */
export function isWarmTransferInProgressStage(
  stage: WarmTransferStage
): boolean {
  return (
    stage !== 'idle' &&
    stage !== 'selectTarget' &&
    stage !== 'cancelled' &&
    stage !== 'completed'
  );
}
